/** Admin: per-org secret values (encrypted server-side, never read back). */
import { apiDelete, apiGet, apiPut } from '../client.js';
import type { OrgSecretEntry } from '../types.js';

export function listOrgSecrets(organizationId: string): Promise<OrgSecretEntry[]> {
  return apiGet<OrgSecretEntry[]>(`/api/v1/admin/organizations/${organizationId}/secrets`);
}

export function setOrgSecret(
  organizationId: string,
  fieldKey: string,
  value: unknown,
): Promise<void> {
  return apiPut<void>(
    `/api/v1/admin/organizations/${organizationId}/secrets/${encodeURIComponent(fieldKey)}`,
    { value },
  );
}

export function deleteOrgSecret(organizationId: string, fieldKey: string): Promise<void> {
  return apiDelete<void>(
    `/api/v1/admin/organizations/${organizationId}/secrets/${encodeURIComponent(fieldKey)}`,
  );
}
